module.exports = __webpack_public_path__ + "img/partnerRight.a1271355.jpg";